if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        const sectionId = this.dataset.sectionId;
        this.targetButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
        this.stickyButton = this.querySelector('.product-sticky-atc__button');
        this.stickyButtonText = this.stickyButton?.querySelector('span');

        if (!this.targetButton || !this.stickyButton) return;

        this.stickyButton.addEventListener('click', (event) => {
          event.preventDefault();
          if (this.stickyButton.disabled) return;
          this.targetButton.click();
        });

        this.syncState();
        this.stateObserver = new MutationObserver(() => this.syncState());
        this.stateObserver.observe(this.targetButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });

        this.intersectionObserver = new IntersectionObserver(
          ([entry]) => {
            this.classList.toggle('is-pinned', !entry.isIntersecting);
          },
          { threshold: 0, rootMargin: '0px 0px -40px 0px' }
        );
        this.intersectionObserver.observe(this.targetButton);
      }

      disconnectedCallback() {
        this.stateObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }

      syncState() {
        const disabled =
          this.targetButton.hasAttribute('disabled') ||
          this.targetButton.getAttribute('aria-disabled') === 'true';
        this.stickyButton.disabled = disabled;
        const label = this.targetButton.querySelector('span')?.textContent?.trim();
        if (label && this.stickyButtonText) this.stickyButtonText.textContent = label;
      }
    }
  );
}
